module.exports = __webpack_public_path__ + "static/media/yellow-gold.bbe71fed.gif";